"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright (c) 2015-present, Zippy Technologies
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function containsNode(parent, child) {
  if (!parent || !child || !(parent instanceof Element) || !(child instanceof Element)) {
    return false;
  }

  // target node should still be in the tree
  if (!global.document.body.contains(child)) {
    return false;
  }

  var result = true;
  if (parent !== child && !parent.contains(child)) {
    result = false;
  }

  return result;
}

exports.default = containsNode;